import { render, staticRenderFns } from "./Сontacts.vue?vue&type=template&id=5e41516b&scoped=true&"
import script from "./Сontacts.vue?vue&type=script&lang=js&"
export * from "./Сontacts.vue?vue&type=script&lang=js&"
import style0 from "./Сontacts.vue?vue&type=style&index=0&id=5e41516b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e41516b",
  null
  
)

export default component.exports